import { gql } from '@urql/core';

export const VENDOR_LIST_QUERY = gql`
  query VendorList {
    vendors {
      nodes {
        id
        companyName
        address {
          city
          country
        }
        contact {
          name
        }
      }
    }
  }
`;

export const VENDOR_ONE_QUERY = gql`
  query VendorOne($id: String!) {
    vendor(id: $id) {
      id
      companyName
      address {
        phones
        email
        pobox
        addressLine
        city
        country
      }
      contact {
        name
        address {
          phones
          email
          pobox
          addressLine
          city
          country
        }
      }
      tin
      isLocal
    }
  }
`;

export const CREATE_VENDOR_MUTATION = gql`
  mutation CreateVendor($input: CreateVendorInput!) {
    createVendor(input: $input) {
      id
      companyName
      address {
        phones
        email
        pobox
        addressLine
        city
        country
      }
      contact {
        name
        address {
          phones
          email
          pobox
          addressLine
          city
          country
        }
      }
      tin
      isLocal
    }
  }
`;

export const UPDATE_VENDOR_MUTATION = gql`
  mutation UpdateVendor($id: String!, $input: UpdateVendorInput!) {
    updateVendor(id: $id, input: $input) {
      id
      companyName
      address {
        phones
        email
        pobox
        addressLine
        city
        country
      }
      contact {
        name
        address {
          phones
          email
          pobox
          addressLine
          city
          country
        }
      }
      tin
      isLocal
    }
  }
`;

export const DELETE_VENDOR_MUTATION = gql`
  mutation DeleteVendor($id: String!) {
    deleteVendor(id: $id) {
      id
      companyName
      address {
        phones
        email
        pobox
        addressLine
        city
        country
      }
      contact {
        name
        address {
          phones
          email
          pobox
          addressLine
          city
          country
        }
      }
      tin
      isLocal
    }
  }
`;